import axios from 'axios';
import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    window.EventManager.on('fetch_infinite_scroll_article', data => {
      this.fetchArticleIds(data)
    });
  }

  disconnect() {
    window.EventManager.off('fetch_infinite_scroll_article', () => { this.fetchArticleIds() });
  }

  fetchArticleIds(data) {
    const pageInfo = data.pageInfo;
    if (pageInfo.ids.length >= pageInfo.limit_num) {
      return
    }

    axios.post(pageInfo.api, {
      ids: pageInfo.ids,
      tags: pageInfo.tags
    }).then(({ data }) => {
      if (data.length) {
        window.EventManager.emit('fetch_infinite_scroll_next_article', {
          next: data
        })
      }
    })
  }
}
